import { call } from 'redux-saga/effects';
import { eventBus, SDKConnectionPayload } from 'utils/eventBus';
import { virtualBackgroundItemsSchema } from 'features/virtual-backgrounds/schemas';
import { adaptBlurBackgrounds } from 'features/virtual-backgrounds/blurValueMap';
import { fromZodError } from 'zod-validation-error';

export function* validateSDKInitStateSaga(initState: SDKConnectionPayload) {
  const returnState = { ...initState };

  if (returnState.initials) {
    if (returnState.initials.length < 1 || returnState.initials.length > 2) {
      yield call(eventBus.error, {
        name: 'initials',
        message: `Invalid initials provided. Initials string must be 1 or 2 characters long, without whitespaces`,
      });

      returnState.initials = undefined;
    }
  }

  if (
    returnState.replaceVirtualBackgrounds &&
    (!returnState.virtualBackgrounds || returnState.virtualBackgrounds.length === 0)
  ) {
    yield call(eventBus.error, {
      name: 'virtual-bg',
      message:
        'Cannot replace default backgrounds without providing custom backgrounds. Default backgrounds are preserved.',
    });

    returnState.replaceVirtualBackgrounds = false;
  }

  if (returnState.virtualBackgrounds) {
    const validationData = virtualBackgroundItemsSchema.safeParse(
      adaptBlurBackgrounds(returnState.virtualBackgrounds)
    );

    if (!validationData.success) {
      const validationError = fromZodError(validationData.error);

      yield call(eventBus.error, {
        name: 'virtual-bg',
        message: validationError.toString(),
      });

      returnState.virtualBackgrounds = undefined;
    } else {
      returnState.virtualBackgrounds = validationData.data;
    }
  }

  return returnState;
}
